// One status per catalog entry (GET /api/crm/integrations/), from its config
// rows. A refused Dealerspace authorization outranks a pending one, and both
// outrank enabled/disabled, even on a disabled config: it can't be turned
// back on until the technical team fixes the authorization.
export function integrationStatus({ configs = [] }) {
  if (configs.length === 0) return 'available';
  if (configs.some((config) => config.authorization === 'refused')) return 'actionRequired';
  if (configs.some((config) => config.authorization === 'pending')) return 'inProgress';
  return configs.some((config) => config.enabled) ? 'active' : 'inactive';
}

// A catalog `manual_setup` integration has a step only the technical team can
// do (Dealerspace: the API v3 authorization), so its form says so until it's active.
export const needsManualSetup = (integration) =>
  Boolean(integration?.manual_setup) && integrationStatus(integration) !== 'active';

// SoftChip color and the card's call to action for each status.
export const statusMeta = {
  available: { color: 'default', action: 'configure' },
  inProgress: { color: 'info', action: 'continue' },
  actionRequired: { color: 'warning', action: 'continue' },
  active: { color: 'success', action: 'manage' },
  inactive: { color: 'default', action: 'manage' },
};

export const STATUSES = Object.keys(statusMeta);

// The pages are customer-wide for now: they manage the default row
// (business_uuid null; stock rows never have one). Per-store CRM rows would
// add a business selector here.
export const customerConfig = (integration) => integration?.configs?.find((config) => config.business_uuid === null);

// The customer has one default CRM row and one stock row, whatever the provider:
// the other integration of the same type already holding that slot, if any.
export const slotTakenBy = (integrations, integration) =>
  integrations?.find((other) => other.type === integration.type && other.key !== integration.key && customerConfig(other));

// Agents of the active stores, as [{ botId, stores: [name] }]: a stock integration's bot_id is
// one of them, and its inventory applies to every store of that agent.
export function botsOf(stores) {
  const bots = {};
  stores
    .filter((store) => store.ai_bot_id && store.is_active && !store.is_deleted)
    .forEach((store) => { (bots[store.ai_bot_id] ??= []).push(store.display_name); });
  return Object.entries(bots).map(([botId, names]) => ({ botId, stores: names }));
}
